/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const districtOptions = [
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

export default function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    year,
    declarationTime,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    address2,
    province2,
    district2,
    phone2,
    fax2,
    email2,
    contract,
    date,
    organ1,
    organ2,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={year.type}
            name={year.name}
            label={year.label}
            value={values.year}
            error={errors.year && touched.year}
            success={values.year?.toString().length > 0 && !errors.year}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={declarationTime.type}
            name={declarationTime.name}
            label={declarationTime.label}
            value={values.declarationTime}
            error={errors.declarationTime && touched.declarationTime}
            success={values.declarationTime?.toString().length > 0 && !errors.declarationTime}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={taxpayerName.type}
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={taxId1.type}
            name={taxId1.name}
            label={taxId1.label}
            value={values.taxId1}
            error={errors.taxId1 && touched.taxId1}
            success={values.taxId1?.toString().length > 0 && !errors.taxId1}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            type={address.type}
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOptions}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={province.type}
            label={province.label}
            name={province.name}
            value={values.province}
            placeholder={province.placeholder}
            error={errors.province && touched.province}
            success={values.province.length > 0 && !errors.province}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone.name}
            label={phone.label}
            value={values.phone}
            error={errors.phone && touched.phone}
            success={values.phone?.toString().length > 0 && !errors.phone}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax.name}
            label={fax.label}
            value={values.fax}
            error={errors.fax && touched.fax}
            success={values.fax?.toString().length > 0 && !errors.fax}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email.name}
            label={email.label}
            value={values.email}
            error={errors.email && touched.email}
            success={values.email?.toString().length > 0 && !errors.email}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address2.name}
            label={address2.label}
            value={values.address2}
            error={errors.address2 && touched.address2}
            success={values.address2?.toString().length > 0 && !errors.address2}
          />
        </Grid>
        <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOptions}
            type={district2.type}
            label={district2.label}
            name={district2.name}
            value={values.district2}
            placeholder={district2.placeholder}
            error={errors.district2 && touched.district2}
            success={values.district2.length > 0 && !errors.district2}
          />
        </Grid>
        <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={province2.type}
            label={province2.label}
            name={province2.name}
            value={values.province2}
            placeholder={province2.placeholder}
            error={errors.province2 && touched.province2}
            success={values.province2.length > 0 && !errors.province2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone2.name}
            label={phone2.label}
            value={values.phone2}
            error={errors.phone2 && touched.phone2}
            success={values.phone2?.toString().length > 0 && !errors.phone2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax2.name}
            label={fax2.label}
            value={values.fax2}
            error={errors.fax2 && touched.fax2}
            success={values.fax2?.toString().length > 0 && !errors.fax2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email2.name}
            label={email2.label}
            value={values.email2}
            error={errors.email2 && touched.email2}
            success={values.email2?.toString().length > 0 && !errors.email2}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contract.name}
            label={contract.label}
            value={values.contract}
            error={errors.contract && touched.contract}
            success={values.contract?.toString().length > 0 && !errors.contract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={date.name}
            label={date.label}
            error={errors.date && touched.date}
            success={values.date?.toString().length > 0 && !errors.date}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={organ1.name}
            label={organ1.label}
            value={values.organ1}
            error={errors.organ1 && touched.organ1}
            success={values.organ1?.toString().length > 0 && !errors.organ1}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={organ2.name}
            label={organ2.label}
            value={values.organ2}
            error={errors.organ2 && touched.organ2}
            success={values.organ2?.toString().length > 0 && !errors.organ2}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
